<div class="menu">
    <span class="menu-heading">
        Account Locked
    </span>
    <span class="close" (click) = "close()">X</span>
</div>
<div class="body-content">
    <span>An email has been sent to you with instructions on how to reset your password.</span>
</div>